/**
 * Shared geographic utility functions.
 * Extracted from ServiceBoardMapView and TrackingMapContainer.
 */

/**
 * Calculate distance between two geographic points using the haversine formula.
 * Pure math — no Google dependencies.
 */
export const haversineDistanceKm = (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number => {
  const R = 6371; // Earth's radius in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

/**
 * Calculate distance between two geographic points.
 * Prefers Google Maps Geometry library (more accurate) when available,
 * falls back to haversine.
 */
export const computeDistanceKm = (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number => {
  // Try Google Maps Geometry library first (more accurate)
  if (
    typeof google !== "undefined" &&
    google.maps?.geometry?.spherical?.computeDistanceBetween
  ) {
    const p1 = new google.maps.LatLng(lat1, lng1);
    const p2 = new google.maps.LatLng(lat2, lng2);
    return google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000;
  }
  // Fallback to haversine
  return haversineDistanceKm(lat1, lng1, lat2, lng2);
};
